

















import { defineComponent, ref } from '@nuxtjs/composition-api';
import { BaseButton, BaseIcon } from '@shared/ui';

export default defineComponent({
  name: 'ReadMoreToggle',
  components: {
    BaseIcon,
    BaseButton,
  },

  setup(_props, context) {
    const isContentCollapsed = ref<boolean>(true);
    const readMoreText = ref<string>('Read More');
    const readMoreIcon = ref<string>('chevron_down');

    const toggleContent = () => {
      context.emit('toggle', isContentCollapsed.value);
      isContentCollapsed.value = !isContentCollapsed.value;
      if (isContentCollapsed.value) {
        readMoreText.value = 'Read More';
        readMoreIcon.value = 'chevron_down';
      } else {
        readMoreText.value = 'Read Less';
        readMoreIcon.value = 'chevron_up';
      }
    };

    return { isContentCollapsed, readMoreText, readMoreIcon, toggleContent };
  },
});
